import moment from 'moment';

import { mapReferralRowToValues } from '../../../../common';
import { TREATMENT_PLAN_V3_REFERRAL_ROW_DATE_FORMAT } from './constants';
import { REFERRAL_FORM_SCHEMA } from './validationSchema';

import type { IReferral } from '../../../../common';

export function getTreatmentPlanV3ReferralRowLabel(row: IReferral): string {
  if (!row.referral_date) return row.provider_name ?? '';
  const formattedDate = moment(row.referral_date).format(
    TREATMENT_PLAN_V3_REFERRAL_ROW_DATE_FORMAT,
  );
  return row.provider_name ? `${formattedDate} - ${row.provider_name}` : formattedDate;
}

export function hasReferralFormErrors(referrals: IReferral[]) {
  if (referrals.length === 0) return true;
  return referrals.some((row) => !REFERRAL_FORM_SCHEMA.isValidSync(mapReferralRowToValues(row)));
}
